export default "__VITE_ASSET__85769cac__"